export default __webpack_public_path__ + "static/articles-psoriazal-sarsaparila-i-psoriazis-65b504d521bc4c641cf297abbeaf6558.jpg";